import { Timer } from "@mui/icons-material";
import { Box, Button, IconButton, Modal, Typography, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function NavigationComponent(props) {

  const theme = useTheme()

  const currentLinks = useSelector(state => state.theme.currentLinks)

  const [menuOpen, setMenuOpen] = useState(false)
  const [isReallyOpen, setIsReallyOpen] = useState(false)

  const refButton = useRef();

  const handleClose = () => {
    setIsReallyOpen(false)
    setTimeout(() => {
      setMenuOpen(false)
    }, 300)
  }

  const handleOpen = () => {
    findTop()
    setMenuOpen(true)
    setTimeout(() => {
      setIsReallyOpen(true)
    }, 100)
  }

  const toggleMenu = () => {
    if(menuOpen){
      handleClose()
    }else {
      handleOpen()
    }
  }

  const handleClick = (id) => {
    const anchor = document.getElementById(id)
    handleClose();
    if (anchor) {
      setTimeout(() => {
        anchor.scrollIntoView({
          alignToTop: true,
          behavior: 'smooth',
          // block: 'center',
        })
      }, 200);
    }
  }

  const [buttonPositionX, setButtonPositionX] = useState(null)
  const [buttonPositionY, setButtonPositionY] = useState(null)

  const [centerButtonPositionX, setCenterButtonPositionX] = useState(null);
  const [centerButtonPositionY, setCenterButtonPositionY] = useState(null);

  const { t } = useTranslation()

  const [lastTop, setLastTop] = useState("anchor")

  const findTop = () => {

    let closestElement = null;
    let minDistance = Infinity;

    currentLinks.forEach((link, index) => {
    const element = document.getElementById(link.id)

    if (element) {
      const rect = element.getBoundingClientRect();
      const distance = Math.abs(rect.top);

      if (distance < minDistance) {
        minDistance = distance
        closestElement = link
      }
    }

    setLastTop(closestElement)
    });
  }

  useEffect(() => {
    if (refButton.current) {
      setButtonPositionX(refButton.current.getBoundingClientRect().x)
      setButtonPositionY(refButton.current.getBoundingClientRect().y)
      setCenterButtonPositionX(window.innerWidth - refButton.current.getBoundingClientRect().x - 20)
      setCenterButtonPositionY(refButton.current.getBoundingClientRect().y + 20)
    }
  }
    , [buttonPositionX, buttonPositionY, refButton, window.innerWidth, window.innerHeight])

  const styleButton = {
    p: 1,
    width: "40px",
    height: "40px",
    aspectRatio: 1,
    position: "relative",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.primary.main,
    },
    pointerEvents: "auto",
    cursor: "pointer",
    borderRadius: "40px",
    transition: "color 0.3s ease-in-out, transform 0.5s ease-in-out, background 0.3s ease-in-out",
    "span.line": {
      transition: "color 0.3s ease-in-out, transform 0.5s ease-in-out, margin 0.3s 0.3s ease-in-out",
      display: "block",
      height: "5%",
      width: "70%",
      backgroundColor: "currentColor",
      boxSizing: "border-box",
      borderRadius: "10px",
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      "&.first": {
        mt: "-15%",
        transformOrigin: "center center"
      },
      "&.second": {
        mt: "15%",
        transformOrigin: "center center"
      }
    },
    "&.open": {
      "span.line": {
        transition: "color 0.3s ease-in-out, transform 0.5s ease-in-out, margin 0.1s ease-in-out",
        "&.first": {
          mt: "-0%",
          transform: "translate(-50%, -50%) rotate(45deg)"
        },
        "&.second": {
          mt: "0%",
          transform: "translate(-50%, -50%) rotate(-45deg)"
        }
      }
    }
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: 1,
        }}
      >
        <Box
          className={menuOpen ? "navigationButton open" : "navigationButton"}
          ref={refButton}
          onClick={() => {
            toggleMenu()
          }}
          sx={styleButton}
        >
          <span className="line first"></span>
          <span className="line second"></span>
        </Box>

      </Box>
      <Modal
        open={menuOpen}
        onClose={handleClose}
        className="FindModal"
        sx={{
          zIndex: theme.zIndex.drawer,
        }}
      >

        <Box
          className={isReallyOpen ? "open" : ""}
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            pointerEvents: "none",
          }}
        >
          <Box
            className="greenBubble"
            sx={{
              position: "absolute",
              background: theme.palette.primary.main,
              height: "40px",
              width: "auto",
              opacity: 1,
              right: centerButtonPositionX,
              top:  centerButtonPositionY,
              transform: buttonPositionX && buttonPositionY ? "translate(50%, -50%)" : "translate(-50%, -50%)",
              aspectRatio: 1,
              borderRadius: "50%",
              transition: "all 0.3s ease-in-out",
              zIndex: 1000,
              // boxShadow: "inset -35vh -15vh 50vh rgba(0, 100, 0, 0.3)",
              // backgroundImage: "linear-gradient(-45deg, rgba(220, 255, 200, 0.3) 0%, transparent 100%)",
              [theme.breakpoints.down("sm")]: {
                width:"40px",
                height: "auto",
              },
              "&:focus": {
                border: "0px",
                outline: "none",
              },
              ".open &": {
                transition: "all 0.3s ease-in-out",
                height: "200%",
                // boxShadow: "inset -35vh -15vh 50vh rgba(0, 100, 0, 0.3)",
                width:"auto",
                opacity: 1,
                [theme.breakpoints.down("sm")]: {
                  width: "300%",
                  height: "auto",
                  // boxShadow: "inset -52vw -22vw 75vw rgba(0, 100, 0, 0.3)",
                }
              }
            }}>
          </Box>
          <Box sx={{
            pointerEvents: "auto",
            opacity: 0,
            position: "absolute",
            zIndex: 1001,
            display: "flex",
            top: `calc(${buttonPositionY}px + 48px)`,
            right: "0px",
            left: "0px",
            padding: "40px",
            transofrmaOrigin: "top right",
            transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
            transform: "translate(100%, -100%) ",
            flexDirection: "column",
            alignItems: "flex-end",
            [theme.breakpoints.down("sm")]: {
              padding: "24px",
            },
            ".open &": {
              transition: "opacity 0.3s  0.1s ease-in-out, transform 0.3s ease-in-out",
              opacity: 1,
              transform: "translate(0%, 0%) ",
            },
            ".nav-link": {
              "&.active": {
                fontWeight: "bold",
              },
              fontSize: "7vh",
              lineHeight: "1",
              display: "flex",
              gap: "10px",
              alignItems: "center",
              whiteSpace: "nowrap",
              p: 0,
              cursor: "pointer",
              py: 1,
              span: {
                flexShrink: 10,
                overflow: "hidden",
                transition: "all 0.3s ease-in-out",
                width: 0,
              },
              "&:hover": {
                span: {
                  flexShrink: 0,
                  width: "7vh",
                }
              },
              [theme.breakpoints.down("sm")]: {
                fontSize: "5vh",
              },
            }
          }}>
            <Typography
            sx={{
              fontSize: "10vh",
              fontWeight: "bold",
              textAlign: "right",
              width: "100%",
              [theme.breakpoints.down("sm")]: {
                fontSize: "7vh",
              },
            }}
              >
                {t("label_sections")}
              </Typography>
            <Box sx={{

              display: "flex",
              right: "0px",
              left: "0px",
              overflow: "auto",
              height: "70vh",
              transofrmaOrigin: "top right",
              flexDirection: "column",
              alignItems: "flex-end",
              "&::-webkit-scrollbar": {
                zIndex: -1,
                width: "0.4em",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-track":{
                boxShadow: "inset 0 0 0px rgba(0, 0, 0, 0.3)",
                backgroundColor: "rgb(32, 32, 32)",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "darkgrey",
                borderRadius: "10px",
                outline: "0px solid slategrey",
              }
            }}>
            {
              currentLinks.map((link, index) => {
                return(
                  <Box key={"nav-link-"+index} className={ lastTop === link ? "nav-link active":"nav-link"} color={theme.palette.text.primary} onClick={()=>{ handleClick(link.id)}}>{t(link.title)}<span>─</span></Box>
                )
              })
            }
            {/* <Box className={ lastTop === "anchor" ? "nav-link active":"nav-link"} color={theme.palette.text.primary} onClick={()=>{ handleClick("back-to-top-anchor")}}>Intro<span>─</span></Box>
            <Box className={ lastTop === "intro" ? "nav-link active":"nav-link"} color={theme.palette.text.primary} onClick={()=>{ handleClick("link-to-scroll-intro")}}>{t("label_title_presentation")}<span>─</span></Box>
            <Box className={ lastTop === "projects" ? "nav-link active":"nav-link"} color={theme.palette.text.primary} onClick={()=>{ handleClick("link-to-scroll-projects")}}>{t("label_projects")}<span>─</span></Box>
            <Box className={ lastTop === "techstack" ? "nav-link active":"nav-link"} color={theme.palette.text.primary} onClick={()=>{ handleClick("link-to-scroll-techstack")}}>Tech stack<span>─</span></Box>
            <Box className={ lastTop === "3d" ? "nav-link active":"nav-link"} color={theme.palette.text.primary} onClick={()=>{ handleClick("link-to-scroll-3d")}}>3D<span>─</span></Box> */}
            </Box>
          </Box>

        </Box>
      </Modal>
    </>
  )
}
